// export const DOMAIN_API = 'https://sslg-app.iriskeysolutions.com/api'

//for Local
// export const DOMAIN_API = 'http://localhost/sslg-paperclip/api';

//for staging
export const DOMAIN_API = '/api';